export default {
  response(request, response) {
    if (response && response.body && response.body.success === false) {
      response.ok = false;
      response.text = 'Request failed: ' + response.body.status;
    }
    return { response };
  }
};
